var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58521",
    "data-name": "Group 58521",
    transform: "translate(6361 19204)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13822",
    "data-name": "Rectangle 13822",
    width: 16,
    height: 16,
    transform: "translate(-6361 -19204)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "trash-2",
    transform: "translate(-6362 -19204)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50718",
    "data-name": "Path 50718",
    d: "M3,6H15",
    transform: "translate(0 -1.257)",
    fill: "none",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50719",
    "data-name": "Path 50719",
    d: "M13,4.863V12.8A1.172,1.172,0,0,1,11.857,14H6.143A1.172,1.172,0,0,1,5,12.8V4.863M6.714,4.4V3.2A1.172,1.172,0,0,1,7.857,2h2.286a1.172,1.172,0,0,1,1.143,1.2V4.4",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1286",
    "data-name": "Line 1286",
    y2: 6,
    transform: "translate(7.667 5.857)",
    fill: "none",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1287",
    "data-name": "Line 1287",
    y2: 6,
    transform: "translate(10.333 5.857)",
    fill: "none",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.3c9476be8d3ba0dbc916519090ef3521.svg";
export { ForwardRef as ReactComponent };